import { createTheme, ThemeProvider } from "@mui/material/styles";
import MUIRichTextEditor, {
  TAutocomplete,
  TCustomControl,
  TDecorator,
  TDraftEditorProps,
  TKeyCommand,
  TToolbarButtonSize,
  TToolbarControl,
} from "mui-rte";
import { EditorState } from "draft-js";
import { Token } from "../theme";

const richTextEditorTheme = createTheme();

Object.assign(richTextEditorTheme, {
  overrides: {
    MUIRichTextEditor: {
      root: {
        marginTop: 10,
        width: "100%",
        height: "100%",
        marginLeft: "0.438em",
        borderBottomStyle: "solid",
        borderLeftStyle: "solid",
        borderRightStyle: "solid",
        borderRadius: "0.188em",
        borderBottomWidth: "0.063em",
        borderLeftWidth: "0.063em",
        borderRightWidth: "0.063em",
        borderBottomColor: "gray",
        borderLeftColor: "gray",
        borderRightColor: "gray",
      },
      editor: {
        display: "block",
        padding: "0 0.375em",
        marginTop: 2,
        marginBottom: 15,
      },
      toolbar: {
        display: "block",
        order: 2,
        position: "relative",
        backgroundColor: Token.surfaceSunken,
        borderTopStyle: "solid",
        borderTopWidth: "0.063em",
        borderTopColor: Token.borderDefault,
      },
      placeHolder: {
        position: "relative",
        color: "DimGray",
      },
      editorContainer: {
        padding: 13,
        margin: 0,
      },
    },
  },
});

export const AppTextEditor = (props: {
  label: string;
  defaultValue?: string;
  readOnly?: boolean;
  onChange?: (state: EditorState) => void;
}): JSX.Element => {
  return (
    <ThemeProvider theme={richTextEditorTheme}>
      <MUIRichTextEditor
        label={props.label}
        inlineToolbar
        defaultValue={props.defaultValue}
        readOnly={props.readOnly}
        onChange={props.onChange}
        controls={[
          "title",
          "bold",
          "italic",
          "underline",
          "strikethrough",
          "highlight",
          "undo",
          "redo",
          "bulletList",
          "numberList",
          "code",
          "clear",
        ]}
      />
    </ThemeProvider>
  );
};

interface Props {
  value?: any;
  defaultValue?: any;
  label?: string;
  readOnly?: boolean;
  inheritFontSize?: boolean;
  error?: boolean;
  controls?: Array<TToolbarControl>;
  customControls?: TCustomControl[];
  decorators?: TDecorator[];
  toolbar?: boolean;
  toolbarButtonSize?: TToolbarButtonSize;
  inlineToolbar?: boolean;
  inlineToolbarControls?: Array<TToolbarControl>;
  draftEditorProps?: TDraftEditorProps;
  keyCommands?: TKeyCommand[];
  maxLength?: number;
  autocomplete?: TAutocomplete;
  onSave?: (data: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  onChange?: (state: EditorState) => void;
}

const defaultProps: Props = {
  label: "",
  defaultValue: "",
};

AppTextEditor.defaultProps = defaultProps;

export default function RichTextEditor(props: Props) {
  return (
    <ThemeProvider theme={richTextEditorTheme}>
      <MUIRichTextEditor {...props} />
    </ThemeProvider>
  );
}
